import { animate, style, transition, trigger } from '@angular/animations';

const easing = '0.3s ease';

export const fadeInOutDropdownComponent = trigger('fadeInOutDropdownComponent', [
  transition(':enter', [
    style({
      opacity: 0,
      position: 'fixed',
      transform: 'translateY(-20px) scale(1.05)',
    }),
    animate(easing, style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, position: 'fixed' }),
    animate(easing, style({ opacity: 0, transform: 'translateY(-20px) scale(1.05)' })),
  ]),
]);
